import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Target } from 'lucide-react';
import { useCreativeWorkbench } from '../CreativeWorkbenchContext';
import { PersonaSteeringMatrix } from './PersonaSteeringMatrix';
import { SteeringCellInspector } from './SteeringCellInspector';
import {
  EmbeddedChatPanel,
  type ChatSeedInput,
} from './EmbeddedChatPanel';
import type { WorkbenchSteeringCell } from '@/services/api';

export function SteeringInvestigationView() {
  const navigate = useNavigate();
  const { clientUid } = useCreativeWorkbench();
  const [selectedCell, setSelectedCell] = useState<WorkbenchSteeringCell | null>(
    null,
  );
  const [chatSeed, setChatSeed] = useState<ChatSeedInput | null>(null);

  if (!clientUid) {
    return (
      <div className="text-sm text-slate-500">
        Pick a client in the header to inspect steering.
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <header className="flex items-center gap-3">
        <button
          onClick={() => navigate('/creative/performance')}
          className="p-1.5 text-slate-500 hover:text-teal-600 rounded hover:bg-slate-100"
          aria-label="Back"
        >
          <ArrowLeft size={16} />
        </button>
        <div>
          <div className="text-[10px] font-mono uppercase text-slate-400">
            Steering investigation
          </div>
          <h1 className="text-xl font-bold text-navy-900 flex items-center gap-2">
            <Target size={18} className="text-teal-500" />
            Persona Steering — drilling the matrix
          </h1>
        </div>
      </header>

      <PersonaSteeringMatrix
        onCellSelect={setSelectedCell}
        onDrillDown={setChatSeed}
      />

      {selectedCell && (
        <SteeringCellInspector
          cell={selectedCell}
          onClose={() => setSelectedCell(null)}
          onDrillDown={setChatSeed}
        />
      )}

      {chatSeed && (
        <div className="fixed bottom-4 right-4 w-96 z-30">
          <EmbeddedChatPanel
            seed={chatSeed}
            onClose={() => setChatSeed(null)}
          />
        </div>
      )}
    </div>
  );
}
